import { render, staticRenderFns } from "./TermsRoot.vue?vue&type=template&id=b1defc96"
import script from "./TermsRoot.vue?vue&type=script&lang=ts"
export * from "./TermsRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports